"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        focused: {
            '&::after': {
                backgroundColor: theme_1.default.colors.primary,
            },
        },
        underline: {
            '&:before, &:after': {
                border: 'none !important',
                height: 2,
                borderRadius: 4,
            },
            '&:before': {
                backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.08)),
            },
            '&:hover:before': {
                backgroundColor: theme_1.default.textColors.primaryLight,
            },
        },
        focusedUnderline: {
            '&:before': {
                backgroundColor: theme_1.default.colors.primary,
            },
            '&:hover:before': {
                backgroundColor: theme_1.default.colors.primary,
            },
        },
        input: function (_a) {
            var fontVariant = _a.fontVariant;
            return (__assign(__assign({}, theme_1.default.fonts[fontVariant]), { color: theme_1.default.textColors.primary, padding: '0px !important', marginBottom: 4, height: 'auto', fontFamily: theme_1.default.fontFamily, overflow: 'hidden', textOverflow: 'ellipsis', '&::placeholder': __assign(__assign({}, theme_1.default.fonts[fontVariant]), { fontWeight: 'normal', fontFamily: theme_1.default.fontFamily, color: theme_1.default.textColors.primary, opacity: 0.5, overflow: 'hidden', whiteSpace: 'nowrap' }) }));
        },
        multiline: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        inputMultiLine: {
            overflow: 'auto !important',
        },
        inputWithDarkPlaceholder: {
            '&::placeholder': {
                opacity: '0.7 !important',
            },
        },
        error: {
            '&::after': {
                backgroundColor: theme_1.default.colors.error,
            },
        },
        disabled: {
            pointerEvents: 'none',
            opacity: '0.5',
        },
        outline: {
            border: theme_1.default.borders.primary,
            padding: '6px 8px',
            borderRadius: 4,
            transition: theme_1.default.transitions.easeOutFast,
            '&.Mui-error': {
                border: theme_1.default.borders.error,
            },
        },
        outlineInput: {
            margin: '0px !important',
        },
        outlineOnHover: {
            border: '1px solid transparent',
            '&:hover': {
                border: theme_1.default.borders.primary,
            },
        },
        focusedOutline: {
            border: theme_1.default.borders.highlight,
            '&:hover': {
                border: theme_1.default.borders.highlight,
            },
        },
        autoGrowthWrapper: {
            display: 'inline-grid',
        },
        autoGrowthElement: {
            gridArea: '1 / 1 / 2 / 2',
            width: 'auto',
        },
        autoGrowthRefEle: function (_a) {
            var fontVariant = _a.fontVariant;
            return (__assign(__assign({}, theme_1.default.fonts[fontVariant]), { fontFamily: theme_1.default.fontFamily, gridArea: '1 / 1 / 2 / 2', visibility: 'hidden', whiteSpace: 'pre-wrap', paddingLeft: 2 }));
        },
    });
});
